import React from 'react';
import styled from 'styled-components';
import { useIsMobile } from '../hooks/responsive';

const ContainerElt = styled.div<{ isMobile: boolean }>`
  margin: 165px auto ${({ isMobile }) => (isMobile ? 400 : 300)}px;
  padding: 0 ${({ isMobile }) => (isMobile ? 20 : 50)}px;
  max-width: 1000px;
`;

export const PageContainer: React.FC = props => {
  const { isMobile } = useIsMobile();

  return <ContainerElt isMobile={isMobile}>{props.children}</ContainerElt>;
};
